<template>
  <page-wrapper :title="title">
    <div class="header">
      <sc-button variant="primary" :route="createButton.route">{{
        createButton.label
      }}</sc-button>
    </div>
    <div class="header">
      <div class="row mb-4">
        <div class="col-3">
          <div class="label">ชื่อจริง</div>
          <el-input v-model="query.firstName"></el-input>
        </div>
        <div class="col-3">
          <div class="label">นามสกุล</div>
          <el-input v-model="query.lastName"></el-input>
        </div>
        <div class="col-3">
          <div class="label">Email</div>
          <el-input v-model="query.email"></el-input>
        </div>
        <div class="col-3">
          <div class="label">บัตรประชาชน / Passport</div>
          <el-input v-model="query.identifierId"></el-input>
        </div>
      </div>
      <div class="text-right">
        <sc-button variant="secondary" @click="handleClickSearchButton"
          >ค้นหา</sc-button
        >
      </div>
    </div>
    <div v-if="list.length">
      <p class="mt-3 ml-4">{{totalCount}}</p>
      <div>
        <user-row
          class="user-row"
          v-for="item in list"
          v-bind="item"
          :key="item.id"
        ></user-row>
        <div class="text-right mt-4" v-if="list.length">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :size="10"
            :current-page="queryParams.page"
            @current-change="handleCurrentChange"
          ></el-pagination>
        </div>
      </div>
    </div>
    <div v-else class="text-center p-5">
      <h3>ไม่มีข้อมูล</h3>
    </div>
  </page-wrapper>
</template>

<script>
import { Input, Pagination } from "element-ui";
import PageWrapper from "@/lib/components/PageWrapper";
import ScButton from "@/lib/components/ScButton";
import { baanRueJaiClient } from "@/dependencies";
import UserRow from "../components/UserRow";
import * as R from "ramda";

export default {
  components: {
    PageWrapper,
    ScButton,
    UserRow,
    "el-input": Input,
    "el-pagination": Pagination
  },
  data() {
    const title = "รายการผู้ใช้";
    const createButton = {
      label: "เพิ่มผู้ใช้",
      route: { name: "UserCreatePage" }
    };
    const query = {
      page: 1,
      firstName: "",
      lastName: "",
      identifierId: "",
      email: ""
    };
    const total = 0;

    return {
      title,
      createButton,
      list: [],
      query,
      total
    };
  },
  watch: {
    $route(newRoute) {
      this.setupData();
    }
  },
  computed: {
    hasQuery() {
      return Object.keys(this.query).reduce((has, key) => {
        return has || this.query[key] !== "";
      }, false);
    },
    isQueryChanged() {
      return (
        (!this.hasQuery && !this.$route.query) ||
        !R.equals(this.$route.query, this.query)
      );
    },
    totalCount() {
      const limit = 10;
      const total = this.total.toLocaleString();
      const currentTotalItem = this.list.length;
      const isLastPage = limit > currentTotalItem;
      const currentPage = this.queryParams.page;
      const end = (isLastPage ? total : currentPage * limit).toLocaleString();
      const start = (
        (isLastPage ? limit * currentPage - limit : end - limit) + 1
      ).toLocaleString();

      return `แสดงผล ${start} - ${end} จากทั้งหมด ${total}`;
    },
    queryParams() {
      return {
        page: parseInt(this.$route.query.page) || 1,
        firstName: this.$route.query.firstName || null,
        lastName: this.$route.query.lastName || null,
        identifierId: this.$route.query.identifierId || null,
        email: this.$route.query.email || null
      };
    }
  },
  created() {
    this.setup();
  },
  methods: {
    setup() {
      this.setupQuery();
      this.setupData();
    },
    setupData() {
      this.setupList();
    },
    setupQuery() {
      const { page = 1, firstName = "", lastName = "", identifierId = "", email = "" } =
        this.$route.query || {};

      this.query = {
        page,
        firstName,
        lastName,
        identifierId,
        email
      };
    },
    async setupList() {
      const { users, count } = await this.fetchList();
      this.total = count;

      this.list = users.map(item => {
        const userProfile = item.user ? item.user.user_profile : item.user_profile;

        const identifierId = userProfile.citizen_id ?
          userProfile.citizen_id :
          userProfile.passport_number;

        const isVerified = item.user_profile.is_verified;

        const home = this.getMainHome(
          isVerified,
          userProfile.default_home_id,
          item.homes
        );

        const id = item.user ? item.user.user_id : item.user_id;
        const route = { name: "UserDetailPage", params: { id } };

        return {
          id,
          email: item.user ?
            item.user.email :
            item.email,
          firstName: userProfile.first_name,
          lastName: userProfile.last_name,
          phoneNumber: userProfile.mobile_number,
          identifierId,
          isVerified,
          home,
          route
        };
      });
    },
    async fetchList() {
      const query = this.$route.query || {};
      const response = await baanRueJaiClient.admin.users.list(query);

      return response.data.result;
    },
    getMainHome(isVerified, mainHomeId, homes) {
      if (!homes || homes.length === 0) {
        return null;
      }

      const home = homes.find(h => h.homeId === mainHomeId) || homes[0];

      return {
        addressNumber: home.address_no,
        projectName: home.project_name,
        userRole: home.user_role
      };
    },
    handleClickSearchButton() {
      if (!this.isQueryChanged) {
        this.setupData();
        return;
      }

      const route = this.hasQuery
        ? { name: "UserListPage", query: { ...this.query, page: 1 } }
        : { name: "UserListPage" };

      this.$router.replace(route);
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page }
      };

      this.$router.replace(route);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.header {
  padding: 30px;
  border-bottom: $border;
}

.user-row {
  padding: 30px;
  border-bottom: $border;
}
</style>



// WEBPACK FOOTER //
// src/features/managements/modules/users/pages/UserListPage.vue